export enum CreationStatuses {
  FilledOnline = "Iesniegts portālā",
  Rejected = "Noraidīts",
  Conflict = "Konflikts",
}
